import React from "react";
import "./Modal.css";

const Modal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = "Confirm",
  showCancelButton = true,
  confirmButtonClassName = "btn-danger",
  cancelButtonClassName = "btn-secondary",
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <h3>{title}</h3>
        <div className="modal-body">{message}</div>
        <div className="modal-actions">
          {showCancelButton && (
            <button className={cancelButtonClassName} onClick={onCancel}>
              Cancel
            </button>
          )}
          <button className={confirmButtonClassName} onClick={onConfirm}>
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
